<template>
  <div class="popup" @click.self.prevent="$emit('close')">
    <div class="popup__container">
      <slot v-if="!loading" />
      <img v-else src="~@/assets/icons/loading-indicator.gif" class="absolute-center" width="55" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onKeyDown(event) {
      if (event.keyCode === 27) {
        this.$emit("close");
      }
    }
  },
  created() {
    document.body.addEventListener("keydown", this.onKeyDown);
  },
  beforeDestroy() {
    document.body.removeEventListener("keydown", this.onKeyDown);
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables";

.popup {
  position: fixed;
  display: flex;
  justify-content: center;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba($color-black, 0.4);
  padding: 0 10px;
  transition: all 0.3s;
  z-index: 999;
  overflow: auto;
  animation: fade 0.5s forwards;
  &__container {
    position: relative;
    background: $color-white;
    transition: all 0.3s 0.1s;
    margin: auto;
    min-width: 1200px;
    max-width: 100%;
    @media all and (max-width: 1200px) {
      min-width: 890px;
    }
  }
}
@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
